import type { PostHog } from "posthog-js";

type PostHogSupportClient = PostHog & {
  setIdentity?: (distinctId: string, hash: string) => void;
  clearIdentity?: () => void;
};

function asPostHogSupportClient(client: PostHog): PostHogSupportClient {
  return client;
}

export function setPosthogSupportIdentity(
  client: PostHog,
  distinctId: string,
  hash: string,
): void {
  asPostHogSupportClient(client).setIdentity?.(distinctId, hash);
}

export function clearPosthogSupportIdentity(client: PostHog): void {
  asPostHogSupportClient(client).clearIdentity?.();
}
